import { render, staticRenderFns } from "./__detail_prescription.vue?vue&type=template&id=c70d0b46&scoped=true&"
import script from "./__detail_prescription.vue?vue&type=script&lang=js&"
export * from "./__detail_prescription.vue?vue&type=script&lang=js&"
import style0 from "./__detail_prescription.vue?vue&type=style&index=0&id=c70d0b46&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c70d0b46",
  null
  
)

export default component.exports